import { useCurrentShopSuspense } from "./use-current-shop-suspense";

export default function useCurrentShopLogoUrl() {
  const { data: shop } = useCurrentShopSuspense();
  return shop.logoUrl;
}
